module.exports = "<app-book [BookName]=\"'js'\" [BookTitle]=\"bookTitle\" [BookId]=\"BookId\"></app-book>"